import {companyActivity} from "./companyActivity";
import { createListSearch } from "./listSearch";
const fields = {
  company: ["companyName", "denomination"],
  contact: ["contactFirstname", "contactLastname", "contacts.firstname", "contacts.lastname", "contacts.profession"],
  phone: ["contactPhone", "phone", "contacts.phone", "contacts.mobile"],
  email: ["contactEMail", "email", "contacts.email"],
  address: ["address", "postCode", "town", "addressLivraison", "postCodeLivraison", "townLivraison", "addressFacturation", "postCodeFacturation", "townFacturation"],
  reference: ["siret", "pld"],
  sector: ["activity", "APE", "searchActivity"],
};
export const createClientSearch = (query, criterion = "all") => {const match=createListSearch(query, criterion === "all" ? Object.values(fields).flat() : fields[criterion] || []);return client=>match({...client,searchActivity:companyActivity(client)});};
export const matchesClientSearch = (client, query, criterion = "all") => createClientSearch(query, criterion)(client);
